import { render } from "./Increment.vue?vue&type=template&id=066f1146&scoped=true"
const script = {}

import "./Increment.vue?vue&type=style&index=0&id=066f1146&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066f1146"]])

export default __exports__